
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function IdareVergiHukuku() {
  const serviceFeatures = [
    {
      title: 'İdari Davalar',
      description: 'İdari işlemlere karşı iptal ve tam yargı davaları',
      icon: 'ri-government-line'
    },
    {
      title: 'Vergi Uyuşmazlıkları',
      description: 'Vergi davaları, ceza kesme işlemleri ve vergi incelemesi',
      icon: 'ri-file-list-line'
    },
    {
      title: 'Kamu İhaleleri',
      description: 'İhale süreçleri, itirazlar ve kamu alımları hukuku',
      icon: 'ri-auction-line'
    },
    {
      title: 'İdari Yaptırımlar',
      description: 'İdari para cezaları ve disiplin işlemlerine karşı savunma',
      icon: 'ri-scales-3-line'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-slate-900 text-white py-20">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/fd5dc8e89696fd7f8a1a33bf9101db1b.jpg')`
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-900/70"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center mb-4 animate-fade-in-up">
              <Link to="/services" className="text-gray-300 hover:text-white transition-colors font-poppins font-light">
                Hizmetler
              </Link>
              <i className="ri-arrow-right-s-line mx-2 text-gray-400"></i>
              <span className="text-white font-poppins font-light">İdare ve Vergi Hukuku</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6 animate-fade-in-up font-poppins" style={{ animationDelay: '0.1s' }}>
              İdare ve Vergi Hukuku
            </h1>
            
            <p className="text-xl text-gray-200 leading-relaxed animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.2s' }}>
              Kamu yönetimi ile olan hukuki ilişkilerinizde uzman danışmanlık. 
              İdari davalar, vergi uyuşmazlıkları ve kamu ihalelerinde profesyonel temsil hizmetleri.
            </p>
          </div>
        </div>
      </section>

      {/* Service Features */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 animate-fade-in-up font-poppins">
              Uzmanlık Alanlarımız
            </h2>
            <div className="w-16 h-0.5 bg-slate-900 mx-auto mb-6"></div>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.1s' }}>
              İdare ve vergi hukuku alanında kapsamlı hizmetler
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {serviceFeatures.map((feature, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-lg border border-gray-100 p-8 hover:shadow-xl transition-all duration-300 animate-fade-in-up hover-lift"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-16 h-16 bg-slate-900 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4 font-poppins">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed font-poppins font-light">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Detailed Content */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-slate-900 mb-8 animate-fade-in-up font-poppins">
            İdare ve Vergi Hukuku Hizmetlerimiz
          </h2>
          
          <div className="space-y-6 text-slate-600 leading-relaxed font-poppins font-light">
            <p className="animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
              İdare ve vergi hukuku, kamu yönetimi ile vatandaş ve kurumlar arasındaki hukuki 
              ilişkileri düzenleyen önemli bir alandır. Bu konularda uzman kadromuzla, 
              müvekkillerimizin kamu idaresi karşısındaki haklarını koruyoruz ve en etkili 
              hukuki çözümleri sunuyoruz.
            </p>
            
            <p className="animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
              İdari davalar konusunda, idari işlemlerin iptali, tam yargı davaları ve idari 
              yaptırımlara karşı başvurularda müvekkillerimizi temsil ediyoruz. Vergi 
              uyuşmazlıklarında ise vergi incelemelerinden vergi davalarına kadar tüm 
              süreçlerde danışmanlık ve temsil hizmeti veriyoruz.
            </p>
            
            <p className="animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
              Kamu ihale süreçlerinde, ihale öncesi danışmanlıktan ihale sonrası uyuşmazlıklara 
              kadar kapsamlı hizmet sunuyoruz. İdari para cezaları, ruhsat iptalleri ve diğer 
              idari yaptırımlara karşı etkili savunma stratejileri geliştiriyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4 animate-fade-in-up font-poppins">
            İdare ve Vergi Hukuku Danışmanlığı
          </h2>
          <p className="text-lg text-gray-200 mb-8 animate-fade-in-up font-poppins font-light" style={{ animationDelay: '0.1s' }}>
            Kamu yönetimi karşısında haklarınızı koruyun
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <button className="bg-white text-slate-900 px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer">
              İdari Dava
            </button>
            <button className="border border-white text-white px-8 py-3 rounded-lg hover:bg-white hover:text-slate-900 transition-colors font-poppins font-semibold whitespace-nowrap cursor-pointer">
              Vergi Danışmanlığı
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
